import React, { useState } from "react";
import styles from "./Contact.module.css";
import ReCAPTCHA from "react-google-recaptcha";

const Contact = () => {
  const [formData, setFormData] = useState({ name: "", email: "", message: "" });
  const [status, setStatus] = useState("");
  const [recaptchaToken, setRecaptchaToken] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!recaptchaToken) {
      setStatus("Please verify that you are not a robot.");
      return;
    }

    setLoading(true);

    try {
      const serverUrl = process.env.REACT_APP_SERVER_URL || "http://localhost:3030";

      const response = await fetch(`${serverUrl}/public/contact`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({
          name: formData.name,
          email: formData.email,
          message: formData.message,
          recaptchaToken: recaptchaToken,
        }),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || "Something went wrong.");
      }

      setStatus("Message sent successfully!");
      setFormData({ name: "", email: "", message: "" });
    } catch (err) {
      setStatus(err.message || "Something went wrong.");
    } finally {
      setLoading(false);
    }
    setTimeout(() => setStatus(""), 3000);
  };

  return (
    <div className={styles["contact-main"]}>
      <div className={styles["contact-sub"]}>
        <h3 className={styles.title}>Contact Us</h3>
        <form onSubmit={handleSubmit}>
          <div className={styles["input-section"]}>
            <div className={styles["input-group"]}>
              <label htmlFor="name">Name</label>
              <input
                type="text"
                id="name"
                name="name"
                value={formData.name}
                onChange={handleChange}
                placeholder="Enter your name"
                required
              />
            </div>
            <div className={styles["input-group"]}>
              <label htmlFor="email">Email</label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="Enter your email"
                required
              />
            </div>
            <div className={styles["input-group"]}>
              <label htmlFor="message">Message</label>
              <textarea
                id="message"
                name="message"
                value={formData.message}
                onChange={handleChange}
                placeholder="How can we help you?"
                required
              ></textarea>
            </div>
            <div style={{ marginBottom: "1rem" }}>
              <ReCAPTCHA
                sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY || "6LeRxY4sAAAAAAkYY1RcR9lrcsPDuTOcFw2np3jQ"}
                onChange={(val) => setRecaptchaToken(val)}
              />
            </div>
            <button type="submit" className={styles.btn} disabled={loading}>
              {loading ? "Sending..." : "Send Message"}
            </button>
            {status && (
              <p style={{ color: "#00ffff", textAlign: "center", marginTop: "15px", fontWeight: "500" }}>
                {status}
              </p>
            )}
          </div>
        </form>
      </div>
    </div>
  );
};

export default Contact;
